export const ADMIN_ONLY = ["ADMIN", "SUPER_ADMIN"];
